const customersUserType = [
  { id: 1, name: 'Crédito' },
  { id: 2, name: 'Contado' }
]

export default customersUserType
